import React, { useEffect, useContext } from 'react';
import { PageContext } from 'lib/PageProvider';
import { useTranslation } from "react-i18next";
import { EnvironmentalImpactWidget } from './widgets/EnvironmentalImpactWidget';
import UserBillsWidgetWrapper from './widgets/UserBillsWidgetWrapper';
import { UsageSummaryWidget } from 'components/widgets/UsageSummaryWidget';
import AccountSummaryWidgetWrapper from 'components/widgets/AccountSummaryWidgetWrapper';
import { NotificationsWidget } from 'components/widgets/NotificationsWidget';
import NeighborhoodCompareWidget from 'components/widgets/NeighborhoodCompareWidget';
import { Grid } from '@mui/material';
import { useResponsive } from 'lib/useResponsive';
import { EnsureAccount } from 'components/customer/accounts/EnsureAccount';
import { useMyOrgs } from 'components/customer/orgs/MyOrgAPIEndpoints';
import { useHasModule } from "components/auth/PermissionApiEndpoint";
import { AccountContext } from 'lib/AccountProvider';
import QuickActionsWidgetWrapper from './widgets/QuickActionsWidgetWrapper';
import { useQuickActions } from "./admin/Dashboard/QuickActionsAPIEndpoints";

export const DashboardPage = () => {
    const { account } = useContext(AccountContext);
    const { t } = useTranslation();
    const { isMobile } = useResponsive();
    const [pageState, pageDispatch] = useContext(PageContext);

    let hasBillingModule = useHasModule("Billing");
    let hasDataWarehouseModule = useHasModule("DataWarehouse");
    const swrQuickActions = useQuickActions(account?.id !== null);
    let utilityHasQuickActionTiles = false;

    if (swrQuickActions?.result && Array.isArray(swrQuickActions.result) && swrQuickActions.result.length > 0) {
        // Check if at least one quick action has isDisplayed set to true
        utilityHasQuickActionTiles = swrQuickActions.result.some(action => action.isDisplayed === true);
    }

    const swrMyOrg = useMyOrgs();
    let orgTempUnit = null;
    let orgMeasurementUnit = null;

    if (!swrMyOrg.isLoading && swrMyOrg.result?.length > 0) {
        orgTempUnit = swrMyOrg.result[0].temperatureUnit;
        orgMeasurementUnit = swrMyOrg.result[0].measurementUnit;
    }

    useEffect(() => {
        pageDispatch({
            header: t("Dashboard"),
            actionItems: [
            ]
        });
    }, [pageState.header, pageDispatch, t, isMobile]);

    const widgetHeight = '450px';

    return (
        <div className="dashboard" data-cy-id="dashboard">
            <EnsureAccount>
                {account?.id !== null && (
                    <Grid container
                        spacing={2}
                        direction="row"
                        alignItems="stretch"
                    >
                        {hasBillingModule ? (
                            <>
                                <Grid height={!isMobile && widgetHeight} item xs={12} sm={12} md={12} lg={4}>
                                    <AccountSummaryWidgetWrapper account={account} />
                                </Grid>
                                <Grid height={!isMobile && widgetHeight} item xs={12} sm={12} md={6} lg={4}>
                                    <UserBillsWidgetWrapper />
                                </Grid> 
                                <Grid height={widgetHeight} item xs={12} sm={12} md={6} lg={4}>
                                    <NotificationsWidget />
                                </Grid>
                                <Grid height={!isMobile && widgetHeight} item xs={12} sm={12} md={6}>
                                    <UsageSummaryWidget
                                        account={account}
                                        orgTempUnit={orgTempUnit}
                                    />

                                </Grid>
                                {hasDataWarehouseModule && (
                                    <Grid height={!isMobile && widgetHeight} item xs={12} sm={12} md={6}>
                                        <NeighborhoodCompareWidget
                                            account={account}
                                            orgMeasurementUnit={orgMeasurementUnit}
                                        />
                                    </Grid>
                                )}
                                {utilityHasQuickActionTiles && (
                                    <Grid height={!isMobile && widgetHeight} item xs={12} sm={12} md={6}>
                                        <QuickActionsWidgetWrapper />
                                    </Grid>
                                )}
                                <Grid height={!isMobile && widgetHeight} item xs={12} sm={12} 
                                    md={(!utilityHasQuickActionTiles && hasDataWarehouseModule) || (utilityHasQuickActionTiles && !hasDataWarehouseModule) ? 12 : 6}>
                                    <EnvironmentalImpactWidget
                                        account={account}
                                        orgMeasurementUnit={orgMeasurementUnit}
                                    />
                                </Grid>
                            </>
                        ) : (
                            <>
                                <Grid height={!isMobile && widgetHeight} item xs={12} sm={12} md={6} lg={4}>
                                    <AccountSummaryWidgetWrapper account={account} />
                                </Grid>
                                <Grid height={!isMobile && widgetHeight} item xs={12} sm={12} md={6} lg={8}>
                                    <UsageSummaryWidget
                                        account={account}
                                        orgTempUnit={orgTempUnit}
                                    />
                                </Grid>
                                {utilityHasQuickActionTiles ? (
                                    <>
                                        {hasDataWarehouseModule && (
                                            <Grid height={!isMobile && widgetHeight} item xs={12} sm={12} md={7}>
                                                <NeighborhoodCompareWidget
                                                    account={account}
                                                    orgMeasurementUnit={orgMeasurementUnit}
                                                />
                                            </Grid>
                                        )}
                                        <Grid height={widgetHeight} item xs={12} sm={12} md={hasDataWarehouseModule ? 5 : 6}>
                                            <NotificationsWidget />
                                        </Grid>
                                        <Grid height={!isMobile && widgetHeight} item xs={12} sm={12} md={6}>
                                            <QuickActionsWidgetWrapper />
                                        </Grid>
                                        <Grid height={!isMobile && widgetHeight} item xs={12} sm={12} md={hasDataWarehouseModule ? 6 : 12}>
                                            <EnvironmentalImpactWidget
                                                account={account}
                                                orgMeasurementUnit={orgMeasurementUnit}
                                            />
                                        </Grid>
                                    </>
                                ) : (
                                    <>
                                        {hasDataWarehouseModule && (
                                            <Grid height={!isMobile && widgetHeight} item xs={12} sm={12} md={8}>
                                                <NeighborhoodCompareWidget
                                                    account={account}
                                                    orgMeasurementUnit={orgMeasurementUnit}
                                                />
                                            </Grid>
                                        )}
                                        <Grid height={widgetHeight} item xs={12} sm={12} md={hasDataWarehouseModule ? 4 : 6}>
                                            <NotificationsWidget />
                                        </Grid>
                                        <Grid height={!isMobile && widgetHeight} item xs={12} sm={12} md={hasDataWarehouseModule ? 12 : 6}>
                                            <EnvironmentalImpactWidget
                                                account={account}
                                                orgMeasurementUnit={orgMeasurementUnit}
                                            />
                                        </Grid>
                                    </>
                                )}
                            </>
                        )}
                    </Grid>
                )}
            </EnsureAccount>    
        </div>
    );
}
